import { LoadingButton } from "@mui/lab";
import { Avatar, Badge, styled } from "@mui/material";
import verify from "../../Assets/images/verify.png";
import unpublished_icon from "../../Assets/images/unpublished_icon.png";
import React from "react";
import "./storage.css";

function History({ storageHistory, isTabletView, isMobileView }) {
  const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 18,
    height: 18,
    backgroundColor: "white",
    borderRadius: "50%",
  }));

  return (
    <div className="d-flex flex-column">
      <div className={isMobileView ? "mobile-container" : "container"}>
        <ul className={isMobileView ? "mobile-table" : "responsive-table"}>
          {!isMobileView && (
            <li className="table-header">
              <div className="col col-1">#</div>
              <div className="col col-2">Image</div>
              <div className="col col-3">Name</div>
              <div className="col col-4">Email</div>
              <div className="col col-5">Role</div>
              <div className="col col-6">Storage</div>
              <div className={isTabletView ? "col col-9" : "col col-8"}>
                Status
              </div>
            </li>
          )}
          <div
            style={{
              overflow: "auto",
              height: isMobileView
                ? "calc(100vh - 166px)"
                : "calc(100vh - 405px)",
              //   padding: "20px",
              //   paddingRight: "7px",
            }}
          >
            {storageHistory.map((history, index) => {
              return (
                <li className="table-row" key={history.email}>
                  <div
                    className="col col-1"
                    data-label="Index"
                    style={{ padding: "18px" }}
                  >
                    {index + 1}
                  </div>
                  <div
                    className="col col-2"
                    data-label="Image"
                    style={{
                      padding: "8px",
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Badge
                      overlap="circular"
                      style={{ zIndex: "0" }}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      badgeContent={
                        history.status !== "pending" && (
                          <SmallAvatar
                            alt="icon"
                            src={
                              (history.status === "rejected" &&
                                unpublished_icon) ||
                              (history.status === "approved" && verify)
                            }
                          />
                        )
                      }
                    >
                      <Avatar>{history.name.charAt(0).toUpperCase()}</Avatar>
                    </Badge>
                  </div>
                  <div
                    className="col col-3"
                    data-label="Name"
                    style={{ padding: "18px" }}
                  >
                    {history.name}
                  </div>
                  <div
                    className="col col-4"
                    data-label="Email"
                    style={{ padding: "18px" }}
                  >
                    {history.email}
                  </div>
                  <div
                    className="col col-5"
                    data-label="Role"
                    style={{ padding: "18px" }}
                  >
                    {history.role}
                  </div>
                  <div
                    className="col col-6"
                    data-label="Available Credits"
                    style={{ padding: "18px" }}
                  >
                    {history.storage}
                  </div>
                  <div
                    className={isTabletView ? "col col-9" : "col col-8"}
                    data-label="Action"
                    style={{
                      padding: "10px",
                      paddingRight: history.status
                        ? history.status === "approved"
                          ? "51px"
                          : "56px"
                        : "10px",
                    }}
                  >
                    {history.status && (
                      <LoadingButton
                        disabled
                        loadingPosition="start"
                        className={
                          history.status === "approved"
                            ? "iconButton"
                            : "rejectIcon"
                        }
                        sx={{
                          color:
                            history.status === "approved" ? "green" : "red",
                          height: "35px",
                          textTransform: "capitalize",
                        }}
                        endIcon={
                          history.status === "approved" ? (
                            <img
                              src={verify}
                              style={{
                                marginRight: "5px",
                                width: "22px",
                                height: "22px",
                              }}
                            />
                          ) : (
                            <img
                              src={unpublished_icon}
                              style={{
                                marginRight: "5px",
                                width: "22px",
                                height: "22px",
                              }}
                            />
                          )
                        }
                      >
                        {history.status === "rejected"
                          ? "Rejected"
                          : history.id
                          ? "Approved"
                          : "Assigned"}
                      </LoadingButton>
                    )}
                  </div>
                </li>
              );
            })}
          </div>
        </ul>
      </div>
    </div>
  );
}

export default History;
